var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PuzzleCell',{class:{
        'c-grid__cell--input': true,
        'c-grid__cell--solution': _vm.isSolutionCell,
        'c-grid__cell--highlighted': _vm.isHighlighted,
        'c-grid__cell--connected': _vm.hasActiveNumberConnector,
        'c-grid__cell--active': _vm.isActive
    },attrs:{"xIndex":_vm.xIndex,"yIndex":_vm.yIndex,"text":_vm.text ? _vm.text.toUpperCase() : '',"placeholderText":_vm.placeholderText,"placeholderTextIsSmall":_vm.isActive || !!_vm.text},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }